import React from "react";
// graphics
import Blob from "./graphics/Blob";
import CreditCard from "./graphics/CreditCard";
import Ellipses from "./graphics/Ellipses";
import Union from "./graphics/Union";

const cardAnimationLoading = () => {
  return (
    <section className="cardAnimationLoading">
      <div className="cardAnimationLoading__imageHolder">
        <div className="blob">
          <div className="graphics">
            <Union svgId="unionOne" />
            <Ellipses svgId="ellipseOne" transparent />
            <Union svgId="unionTwo" />
            <Union svgId="unionThree" />
            <Ellipses svgId="ellipseTwo" transparent />
            <Ellipses svgId="ellipseThree" transparent />
            <Union svgId="unionFour" />
          </div>
          <Blob className="cardAnimationLoading__image--creditcard" />
          <CreditCard />
        </div>
      </div>
      <div className="cardAnimationLoading__text">
        <h2>We&apos;re processing your order</h2>
        <div className="ellipsesHolder">
          <Ellipses svgId="ell_1" transparent={false} />
          <Ellipses svgId="ell_2" transparent={false} />
          <Ellipses svgId="ell_3" transparent={false} />
        </div>
      </div>
    </section>
  );
};
export default cardAnimationLoading;
